import { Box, Divider, styled } from '@ltvco/refresh-lib/theme';

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '24px',
    padding: theme.spacing(0, 2),
  },
}));

export const DropdownsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flexDirection: 'column',
    gap: '16px',
  },
}));

export const VerticalDivider = styled(Divider)(({ theme }) => ({
  height: '40px',
  borderColor: theme.palette.divider,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
